const assert = require('./assert');

/**
 * Creates observer w
 *
 * @returns {}
 */
module.exports = function observerFactory() {
  let registry = [];

  const observe = function(callback) {
    assert.check(callback, { type: 'function', message: 'Callback must be a function' });
    registry.push(callback);
    const callbackIndex = registry.length - 1;

    // Return unsubscriber
    return function() {
      registry = registry.slice(0, callbackIndex).concat(registry.slice(callbackIndex + 1));
    };
  };

  const trigger = function() {
    const args = Array.prototype.slice.call(arguments);
    registry.forEach(function(callback) {
      callback.apply(null, args);
    });
  };

  return [observe, trigger];
};
